
<div class="card p-2">
  <div class="ngxTableHeader" id="excel-table">
    <ul class="header-buttons-left ms-0 mb-0">
      <li class="dropdown text-center">
        <h2>Hospital Wise Occupancy Reports</h2>
      </li>
    </ul>
    <ul class="header-buttons mr-2">
      <!--      <li>-->
      <!--        <button   mat-mini-fab color="primary" (click)="openAddCarLog()">-->
      <!--          <mat-icon class="col-white" >add</mat-icon>-->
      <!--        </button>-->
      <!--      </li>-->

      <li>
<!--        <div  class="export-button m-l-10" matTooltip="XLSX" (click)="exportexcel()">-->
<!--          <img src="assets/images/icons/xlsx.png" alt="" />-->
<!--        </div>-->
        <div  class="export-button m-l-10" matTooltip="XLSX" (click)="printDoc()" permission="Hospital Wise Occ." [permissionTypes]="[PermissionType.ALL, PermissionType.EXCEL]">
          <img src="assets/images/icons/pdf.png" alt="" />
        </div>
      </li>
    </ul>
  </div>
  <div><p><strong>Note: </strong>At the time of printing please use landscape mode for better visibility of hospital column in centre row.</p></div>
  <mat-progress-bar *ngIf="isLoading" mode="indeterminate">Please wait Data is loading... </mat-progress-bar>
  <div id="preview">
    <h4 class="text-center section-header" style="text-align: center; font-size: 1rem; font-weight: bold; margin: 10px 0;">
      OUTSTATION ({{todayDate | date:'dd-MM-yyyy' }})
    </h4>

    <table class="table table-bordered" style="width: 100%; border-collapse: collapse; border: 1px solid #ddd; margin: 10px 0;">
      <thead>
      <tr>
        <td class="font-bold" style="font-weight: bold; padding: 8px; border: 1px solid #ddd;">Total :</td>
        <td class="font-bold" style="font-weight: bold; padding: 8px; border: 1px solid #ddd;">
          Capacity : {{ calculateOutstationAverage().totalCapacity }}
        </td>
        <td class="font-bold" style="font-weight: bold; padding: 8px; border: 1px solid #ddd;">
          Occupied : {{ calculateOutstationAverage().totalOccupied }}
        </td>
        <td class="font-bold" style="font-weight: bold; padding: 8px; border: 1px solid #ddd;">
          Percentage : {{ calculateOutstationAverage().averagePercentage }}%
        </td>
      </tr>
      </thead>
    </table>

    <div class="container">
    <ng-container *ngFor="let center of allCentres">
      <div *ngIf="!isMaharashtraCenter(center.centreName)" class="mb-4">
        <h3 class="center-title">Centre Name: {{ center.centreName }}</h3>
        <table class="table table-bordered table-striped text-center custom-table">
          <thead>
          <tr>
            <th>Capacity</th>
            <th>Occupied</th>
            <th>Per(%)</th>
            <ng-container *ngFor="let h of HospitalName">
              <ng-container *ngIf="h.centreName === center.centreName">
                <th *ngFor="let hospital of h.hospitals">{{ hospital }}</th>
              </ng-container>
            </ng-container>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>{{ center.totalUnits }}</td>
            <td>{{ center.occupiedUnits }}</td>
            <td>{{ getPercentage(center) }}%</td>
            <ng-container *ngFor="let h of HospitalName">
              <ng-container *ngIf="h.centreName === center.centreName">
                <ng-container *ngFor="let hospital of h.hospitals">
                  <td>{{ h.hospitalCount[hospital] || 0 }}</td>
                </ng-container>
              </ng-container>
            </ng-container>
          </tr>
          </tbody>
        </table>
      </div>
    </ng-container>

      <h4 class="text-center section-header" style="text-align: center; font-size: 1rem; font-weight: bold;">MAHARASHTRA ({{todayDate | date:'dd-MM-yyyy'}})</h4>
      <table class="table table-bordered" style="border-collapse: collapse; width: 100%; margin: 10px 0;">
        <thead>
        <tr style="background-color: #f2f2f2; text-align: center;">
          <td class="font-bold" style="font-weight: bold; padding: 8px; border: 1px solid #ddd;">Total :</td>
          <td class="font-bold" style="font-weight: bold; padding: 8px; border: 1px solid #ddd;">Capacity : {{ calculateAverage().totalCapacity }}</td>
          <td class="font-bold" style="font-weight: bold; padding: 8px; border: 1px solid #ddd;">Occupied : {{ calculateAverage().totalOccupied }}</td>
          <td class="font-bold" style="font-weight: bold; padding: 8px; border: 1px solid #ddd;">Percentage : {{ calculateAverage().averagePercentage }}%</td>
        </tr>
        </thead>
      </table>

      <ng-container *ngFor="let center of allCentres">
      <div *ngIf="isMaharashtraCenter(center.centreName)" class="mb-4">
        <h3 class="center-title">Centre Name: {{ center.centreName }}</h3>
        <table class="table table-bordered table-striped text-center custom-table" >
          <thead>
          <tr>
            <th>Capacity</th>
            <th>Occupied</th>
            <th>Per(%)</th>
            <ng-container *ngFor="let h of HospitalName">
              <ng-container *ngIf="h.centreName === center.centreName">
                <th *ngFor="let hospital of h.hospitals">{{ hospital }}</th>
              </ng-container>
            </ng-container>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>{{ center.totalUnits }}</td>
            <td>{{ center.occupiedUnits }}</td>
            <td>{{ getPercentage(center) }}%</td>
            <ng-container *ngFor="let h of HospitalName">
              <ng-container *ngIf="h.centreName === center.centreName">
                <ng-container *ngFor="let hospital of h.hospitals">
                  <td>{{ h.hospitalCount[hospital] || 0 }}</td>
                </ng-container>
              </ng-container>
            </ng-container>
          </tr>
          </tbody>
        </table>
      </div>
    </ng-container>
  </div>
</div>
</div>
